angular.module('wbDashboard').controller('MilestoneOverviewControllerAurea',
    ['$scope', '$filter', '$window', '$timeout', '$uibModal', 'NgTableParams', 'User', 'Milestone',
        'MoreInfoService', 'Account', 'PlanService', 'RiskScore', 'Track',
function ($scope, $filter, $window, $timeout, $uibModal, NgTableParams, User, Milestone,
          MoreInfoService, Account, PlanService, RiskScore, Track) {

    // MoreInfoService.show($scope);
    $scope.pageData.infoTemplate = "milestone.overview.more-info.tpl.html";
    $scope.tabs = {
        active: 'past',
        scrollTop: true,
        data: {
            "future": {
                label: 'Future', value: 'future', callbacks: {
                    afterEnter: function (oldTab, newTab) {
                        Track.send("Milestone Details", "milestone", {milestone_id: $scope.$stateParams.msId, tab: "future"});
                        // angular.element($window).trigger('resize');
                    }
                }
            },
            "past": {
                label: 'Past', value: 'past', callbacks: {
                    beforeEnter: function () { },
                    afterEnter: function (oldTab, newTab) {
                        Track.send("Milestone Details", "milestone", {milestone_id: $scope.$stateParams.msId, tab: "past"});
                        // angular.element($window).trigger('resize');
                    }
                }
            },
            "portfolio": {
                label: 'Portfolio', value: 'portfolio', callbacks: {
                    beforeEnter: function () { },
                    afterEnter: function (oldTab, newTab) {
                        Track.send("Milestone Details", "milestone", {milestone_id: $scope.$stateParams.msId, tab: "portfolio"});
                        // angular.element($window).trigger('resize');
                        $timeout(function () {
                            $window.Waypoint.refreshAll();
                        }, 100);
                    }
                }
            },
            "edit": {
                label: 'Edit', value: 'edit', callbacks: {
                    beforeEnter: function (oldTab, newTab) {
                        if ($scope.pageData.statusCode === $scope.msStatuses.deleting) {return false;}
                    }, afterEnter: function (oldTab, newTab) {
                        Track.send("Milestone Details", "milestone", {milestone_id: $scope.$stateParams.msId, tab: "edit"});
                    }
                }
            }
        }
    };
    if (!User.wbBeta) {
        delete $scope.tabs.data.future;
    }


    $scope.moment = moment;

    $scope.pageData.msStatus = null;
    $scope.msStatuses = {
        good: 'good',
        accountPending: 'accountPending',
        investmentPending: 'investmentPending',
        complete: 'complete',
        abandoned: 'abandoned',
        deleting: 'deleting',
    };

    var currentDate = moment().endOf('day').startOf('second');
    $scope.historyPicker = {
        init: false,
        date: {startDate: null, endDate: null},
        options: {
            pickerClasses: 'dark',
            applyButtonClasses: 'btn-primary',
            cancelButtonClasses: 'btn-outline-primary',
            alwaysShowCalendars: true,
            linkedCalendars: false,
            showDropdowns: true,
            locale: {
                format: "MM-DD-YYYY", //will give you 2017-01-06
                applyLabel: "Filter",
                cancelLabel: 'Cancel',
                customRangeLabel: 'Custom',
                daysOfWeek: ["S", "M", "T", "W", "T", "F", "S"],
            },
            minDate: null,
            maxDate: null,
            ranges: {
                'Last Week': [currentDate.clone().subtract(1, 'week').startOf('day'), currentDate],
                'Last Month': [currentDate.clone().subtract(1, 'month').startOf('day'), currentDate],
                'Last 6 Months': [currentDate.clone().subtract(6, 'months').startOf('day'), currentDate],
                'Last Year': [currentDate.clone().subtract(1, 'year').startOf('day'), currentDate],
                'All Time': [null, null],
            },
            isCustomDate: (date) => {
                var side = null; //arguments.callee.caller.arguments[0];
                if (side==='left') {
                } else if (side==='right') {
                } else {}
                return false;
            }
        }
    };

    $scope.msData = { milestones: null, current: null, total: null };
    $scope.positionData = { positions: null, accountPositions: null, current: null, table: {} };
    $scope.futureData = { futures: null, current: null };
    $scope.historyData = { histories: null, current: null, valueCount: 0 };

    $scope.$watch(function() { return PlanService.user.getAutos(); }, function(autos) {
        $scope.autos = autos;
    });

    $scope.gotoIRAs = function() {
        $scope.$state.go("base.plans.detail.plan.feature.detail",{pslug:'taxplan', fslug:'taxpreferredaccount'});
    };
    $scope.graphHeight = function() {
        return Math.max(window.innerHeight - 400, 250);
    };

    $scope.showProjectionsModal = function() {
        var modalInstance = $uibModal.open({
            templateUrl: 'milestone.overview.future.disclaimer.tpl.html',
            size: 'md',
            scope: $scope,
            windowClass: 'full-head-modal'
        });

        return modalInstance.result.catch(angular.noop);
    };

    function milestoneStatus() {
        //determine milestone status
        if ($scope.milestone.status === 300) {
            $scope.pageData.statusCode = $scope.msStatuses.deleting;
        } else if ($scope.milestone.complete) {
            $scope.pageData.statusCode = $scope.msStatuses.complete;
        } else {
            var account=null, overviewAccount=null;
            if ($scope.milestone.accounts.length === 1) {
                account = $scope.milestone.accounts[0];
                overviewAccount = $filter('filter')($scope.overview.account_overview, {account_number: account.account_number});
            }

            if (account && overviewAccount && ((account.status && account.status !== 200) || (overviewAccount[0] && overviewAccount[0].is_pending))) {
                $scope.pageData.statusCode = $scope.msStatuses.accountPending;
            // } else if (!$scope.milestone.metrics.value && !$scope.milestone.metrics.total_deposits) {
            //     $scope.pageData.statusCode = $scope.msStatuses.investmentPending;
            } else if ($scope.historyData.current && $scope.historyData.valueCount <= 2) {
                $scope.pageData.statusCode = $scope.msStatuses.investmentPending;
            } else if ($scope.milestone.type !== 'build_wealth' && !$scope.milestone.type_account && !$scope.milestone.metrics.estimated_achievement && $scope.milestone.metrics.total_credits) {
                $scope.pageData.statusCode = $scope.msStatuses.abandoned;
            } else {
                $scope.pageData.statusCode = $scope.msStatuses.good;
            }

        }

        // $scope.pageData.statusCode = $scope.msStatuses.deleting;

    }

    User.retrieveMilestones($scope.$stateParams.msId).catch(function(response) {
        if (response.status === 404) $scope.$state.go("base.overview", {}, {location: "replace"});
    });
    $scope.$watchCollection(function() { return User.getMilestones($scope.$stateParams.msId); }, function(milestone) {
        if (milestone) {
            $scope.milestone = milestone;

            if (!$scope.milestone.complete) {
                User.retrieveFutureGraph({msId: milestone.id, est_achievement_date:$scope.milestone.metrics.estimated_achievement}, true);
            }

            if (milestone.allocation.allocation_slug) {
                PlanService.user.retrievePortfolios(milestone.allocation.allocation_slug).then(function (portfolio) {
                    $scope.milestone.extra.portfolioName = portfolio.name;
                    $scope.milestone.extra.target_stock_percent = portfolio.target_stock_rate * 100;
                    $scope.milestone.extra.target_bond_percent = portfolio.target_bond_rate * 100;
                    $scope.milestone.extra.allocationBlurb = $scope.getAllocationBlurb($scope.milestone);
                });
            } else {
                RiskScore.retrievePortfolios().then(function (riskPortfolios) {
                    var risk = riskPortfolios[milestone.allocation.allocation_model];
                    $scope.milestone.extra.target_stock_percent = risk.stock_percent;
                    $scope.milestone.extra.target_bond_percent = risk.bond_percent;
                    $scope.milestone.extra.allocationBlurb = $scope.getAllocationBlurb($scope.milestone);
                });
            }

            $scope.msData.milestones = { client: milestone };

            $scope.msData.current = $scope.msData.milestones.client;

            $scope.msData.total = $scope.setMilestoneTotals(milestone);

        } else {
            //placeholder data
            $scope.milestone = Milestone.loadingMilestone;
        }

    });

    $scope.setMilestoneTotals = function(ms) {
        var metricsTotals = {
            value: 0,
            net_credits: 0,
            earnings: 0,
            dividends: 0,
        };

        var total = {
            metrics: {},
            accounts: ms.accounts,
        };

        angular.forEach(total.accounts, function(account) {
            account.metrics.net_credits = account.metrics.total_credits - account.metrics.total_debits;
            account.metrics.earnings = account.metrics.value - account.metrics.net_credits;

            if (account.metrics.net_credits > 0) {
                account.metrics.simple_return = (account.metrics.earnings / account.metrics.net_credits) * 100;
            } else {
                account.metrics.simple_return = null;
            }

            metricsTotals.value += account.metrics.value;
            metricsTotals.net_credits += account.metrics.net_credits;
            metricsTotals.earnings += account.metrics.earnings;
            metricsTotals.dividends += account.metrics.total_dividends;
        });

        total.metrics = metricsTotals;

        return total;
    };

    $scope.$watchCollection(() => User.getActivityPending(), function (activity) {
        if (activity && $scope.milestone && !$scope.pageData.deleteStatus && $scope.milestone.status === 300) {

            $scope.pageData.deleteStatus = "processing";
            $scope.pageData.msDelete = {
                milestone_to_id: null,
                milestone_to_name: null,
                delete_date: null
            };

            var transferActivity;
            var transferTransaction;
            angular.forEach(activity, function (a) {
                if (a.type === "transfer_transaction" && a.data.transaction.transfer.from_milestone_id === $scope.milestone.id) {
                    if (!transferActivity) {
                        transferActivity = a;
                    }
                }
            });
            if (transferActivity) {
                transferTransaction = transferActivity.data.transaction.transfer;
                $scope.pageData.msDelete.milestone_to_id = transferTransaction.to_milestone_id;
                $scope.pageData.msDelete.milestone_to_name = transferTransaction.to_milestone_name;
                $scope.pageData.msDelete.date_initiated = moment(transferActivity.event_at);
                $scope.pageData.msDelete.date_est_done = $scope.pageData.msDelete.date_initiated.clone().add('3', 'days');
                if ($scope.pageData.msDelete.date_est_done.format('ddd') === 'Sat') { $scope.pageData.msDelete.date_est_done.add('2','days'); }
                if ($scope.pageData.msDelete.date_est_done.format('ddd') === 'Sun') { $scope.pageData.msDelete.date_est_done.add('1','days'); }
            }
        }
    });

    function updateData() {

        updatePositions();
        updateMilestone();
        updateFuture();
        updateHistory();

        //update milestone statuses
        milestoneStatus();

        function updateMilestone() {
            if ($scope.msData.milestones) {
                $scope.msData.current = $scope.msData.milestones.client;
            }
        }
        function updateFuture() {
            if ($scope.futureData.futures) {
                $scope.futureData.current = {plotData: []};
                $scope.futureData.current.plotData.push($scope.futureData.futures.client);
            }
        }
        function updateHistory() {
            if ($scope.historyData.histories) {
                $scope.historyData.current = {plotData: []};
                $scope.historyData.current.plotData.push($scope.historyData.histories.client);
            }
        }
        function updatePositions() {
            var newPositions;
            if ($scope.positionData.positions) {

                if ($scope.positionData.selectedAccount) {
                    newPositions = $scope.positionData.selectedAccount;
                } else if (!$scope.positionData.selectedAccount) {
                    newPositions = $scope.positionData.positions.client;
                }

                $scope.positionData.current = newPositions;

                if ($scope.positionData.table.cols) {
                    $scope.positionData.table.cols[1].show(true);
                    $scope.positionData.table.cols[2].show(false);
                }
            }
        }
    }

    /****************************
     * FUTURE PAGE
     ****************************/
    $scope.$watch(() => User.getFutureGraph($scope.$stateParams.msId), function (msFuture) {
        if (msFuture) {
            $scope.futureData.futures = {
                client: msFuture.client,
            };

            updateData();
        }
    }, true);

    $scope.getEstValue = function() {
        if (false && $scope.milestone.metrics.estimated_achievement) {
            if ($scope.futureData.current) {
                return $scope.futureData.current.plotData[0].values.slice(-1)[0].account_value;
            } else {
                return null;
            }
        } else {
            return $scope.milestone.target_amount;
        }
    };

    /****************************
     * PAST PAGE
     ****************************/
    $scope.$watch(() => User.getMilestoneHistory($scope.$stateParams.msId), function (msHistory) {
        if (msHistory && Object.keys(msHistory).length) {
            $scope.historyData.histories = {
                client: msHistory.client,
            };

            if (!$scope.historyPicker.init) {
                //fresh indicates if the data that was returned had null dates or not
                var fresh = msHistory.fresh;
                var i, valued = 0,
                    initData = $scope.historyData.histories.client
                ;
                for (i=0; i < initData.values.length; i++) {
                    if (initData.values[i].value > 0) {valued++;}
                    if (valued >= 3) {break;}
                }
                $scope.historyData.valueCount = valued;
                if (initData.values.length) {
                    $scope.initHistoryPicker(initData.values[0].date, initData.values.slice(-1)[0], fresh);
                } else {
                    $scope.initHistoryPicker(new Date(), new Date(), false);
                }
            }

            updateData();
        }
    }, true);

    $scope.$watch('historyPicker.date', function (date = {}) {
        if (!$scope.historyPicker.init || date.startDate && date.endDate) {
            $scope.updateMilestoneHistoryRange();
        }
    });
    $scope.updateMilestoneHistoryRange = function() {
        $scope.pageData.loadingHistory = true;
        var data = {};
        if ($scope.historyPicker.init) {
            data = {
                start: $scope.historyPicker.date.startDate.format("YYYY-MM-DD"),
                end: $scope.historyPicker.date.endDate.format("YYYY-MM-DD")
            };
        }
        User.retrieveMilestoneHistory($scope.$stateParams.msId, data).then(function() {
            $scope.pageData.loadingHistory = false;
        });

    };
    /**
     * @param min
     * @param max
     * @param fresh - indicates data was hit without set start and end dates
     */
    $scope.initHistoryPicker = function(min, max, fresh = false) {
        var currentDate = moment().endOf('day').startOf('second');
        var startDate = moment(min).startOf('day');
        var ranges = $scope.historyPicker.options.ranges;
        $scope.historyPicker.date.startDate = startDate;
        $scope.historyPicker.date.endDate = currentDate;
        $scope.historyPicker.options.minDate = startDate;
        $scope.historyPicker.options.maxDate = currentDate;

        ranges['All Time'] = [startDate, currentDate];

        ['Last Month', 'Last 6 Months', 'Last Year'].forEach(function(key) {
            if (ranges[key] && startDate > ranges[key][0]) {
                delete ranges[key];
            }
        });

        if (fresh) {
            $scope.historyPicker.init = true;
        }
    };


    /****************************
     * PORTFOLIO POSITION PAGE
     ****************************/
    User.retrieveMilestonePositions($scope.$stateParams.msId);
    $scope.$watch(() => User.getMilestonePositions($scope.$stateParams.msId), function (msPositions) {
        if (msPositions) {
            $scope.positionData.positions = {
                client: msPositions.client,
            };
            $scope.positionData.accountPositions = msPositions.milestone_accounts;

            updateData();
        }
    }, true);

    //watch to see if the user has selected a specific account to view on portfolios
    $scope.$watch('positionData.selectedAccount', function(account) {
        updateData();
    });

    //update portfolio position table data and displayed columns
    $scope.$watch('positionData.current', function(portfolio) {
        $scope.positionData.table.params = RiskScore.getAssetTableParams(portfolio);
    });

    $scope.getAllocationBlurb = function(ms) {
        var blurb;

        if (ms.id) {
            if (ms.allocation.allocation_slug) {
                blurb = ms.extra.portfolioName;
                if (ms.id === $scope.$stateParams.msId) {
                    //client milestone
                    blurb += ` <a ui-sref="base.plans.custom.portfolioplus.detail({slug: '${$scope.milestone.allocation.allocation_slug}'})">View</a>`;
                }
            } else {
                var percentTotalStock = ms.extra.target_stock_percent * (1 - ms.allocation.cash);
                if (ms.allocation.allocation_model < 0.9) {
                    blurb = (ms.type === 'cash') ? "All Cash" : "Cash";
                } else {
                    if (percentTotalStock < 50) {
                        blurb = "Conservative";
                    } else if (50 <= percentTotalStock && percentTotalStock < 66) {
                        blurb = "Moderate";
                    } else if (66 <= percentTotalStock) {
                        blurb = "Aggressive";
                    }
                }
            }
        } else {
            blurb = "Combined Portfolio";
        }
        blurb = `<h5 class="text-center mt-0 mt-md-3 mb-0">${blurb}</h5>`;

        return blurb;
    };

    $scope.empty = function(obj) {
        return !obj || !!Object.keys(obj).length;
    };

}]);
